import { Pipe, PipeTransform } from '@angular/core';
import { CompleteMedicalCareStruct } from '../../services/structs/orchestrator-patient/complete-medical-care.struct';
import { PrescriptionStatusEnum } from '../../enum/prescription-status.enum';

@Pipe({
    name: 'validateThereArePrescriptions',
    standalone: false
})
export class ValidateThereArePrescriptionsPipe implements PipeTransform {

  transform(functionName: string, medicalCare: CompleteMedicalCareStruct, isHistory: boolean, isMedicatedSolution?: boolean, idCurrentMedicalCare?: number): boolean {
    switch (functionName) {
      case 'validateGeneral':
        return this.validateGeneral(medicalCare, isHistory, idCurrentMedicalCare);
      case 'validateIndividualList':
        return this.validateIndividualList(medicalCare, isHistory, isMedicatedSolution, idCurrentMedicalCare);
      default:
        throw new Error(`Função ${functionName} não implementada.`);
    }
  }

  validateGeneral(medicalCare: CompleteMedicalCareStruct, isHistory: boolean, idCurrentMedicalCare?: number): boolean{
    if(!isHistory) {
      return ((medicalCare.listInternalPrescription.length > 0 
          && medicalCare.listInternalPrescription.filter(x => x.canSuspend).length > 0)
        || (medicalCare.listPrescriptionSolution.length > 0
          &&medicalCare.listPrescriptionSolution.filter(x => x.canSuspend).length > 0));
    }
    if(isHistory) {
      return ((medicalCare.listInternalPrescription.length > 0 
          && medicalCare.listInternalPrescription.filter(x => x.prescriptionMedicine.idPrescriptionStatus == PrescriptionStatusEnum.Suspenso && x.prescriptionMedicine.idMedicalCareSuspended == idCurrentMedicalCare).length > 0)
        || (medicalCare.listPrescriptionSolution.length > 0
          &&medicalCare.listPrescriptionSolution.filter(x => x.idPrescriptionStatus == PrescriptionStatusEnum.Suspenso && x.idMedicalCareSuspended == idCurrentMedicalCare).length > 0));
    }
  }

  validateIndividualList(medicalCare: CompleteMedicalCareStruct, isHistory: boolean, isMedicatedSolution: boolean, idCurrentMedicalCare?: number): boolean {
    if(!isMedicatedSolution) {
      return isHistory ? 
        medicalCare.listInternalPrescription.filter(x => x.prescriptionMedicine.idPrescriptionStatus == PrescriptionStatusEnum.Suspenso && x.prescriptionMedicine.idMedicalCareSuspended == idCurrentMedicalCare).length > 0
        : medicalCare.listInternalPrescription.filter(x => x.canSuspend).length > 0;
    }
    if(isMedicatedSolution) {
      return isHistory ? 
      medicalCare.listPrescriptionSolution.filter(x => x.idPrescriptionStatus == PrescriptionStatusEnum.Suspenso && x.idMedicalCareSuspended == idCurrentMedicalCare).length > 0
      : medicalCare.listPrescriptionSolution.filter(x => x.canSuspend).length > 0;
    }
  }
}

